/**
 * Stow scene after a pack reveal. Standing phones get a binder (the case is
 * too wide). Desktop and landscape keep the Kaiba attaché.
 */

import { CollectionBinder } from './CollectionBinder'
import { CollectionVault, type VaultCallbacks } from './CollectionVault'
import { packFrame } from './packFrame'

export type StowKind = 'case' | 'binder'

export interface StowScene {
  readonly kind: StowKind
  play(): Promise<void>
  skip(): void
  dispose(): void
}

/**
 * Classify the host (or the window if the host has not laid out yet).
 */
export function peekStowKind(host?: HTMLElement | null): StowKind {
  const w =
    host?.clientWidth ||
    (typeof window !== 'undefined' ? window.innerWidth : 1)
  const h =
    host?.clientHeight ||
    (typeof window !== 'undefined' ? window.innerHeight : 1)
  return packFrame(w, h) === 'portrait' ? 'binder' : 'case'
}

/**
 * Build the stow animation that fits this canvas.
 */
export function createStowScene(
  host: HTMLElement,
  cardUrls: string[],
  callbacks: VaultCallbacks = {},
  labelText = 'Collection',
): StowScene {
  if (peekStowKind(host) === 'binder') {
    return new CollectionBinder(host, cardUrls, callbacks, labelText)
  }
  return new CollectionVault(host, cardUrls, callbacks, labelText)
}
